import { DefaultToneDto } from "../../dto/deafulttone/defaulttonedto";
import { APIResponse, APIResponseDtoImpl } from "../apiresponse";

export interface DefaultToneResponse extends APIResponse 
{
    getDefaultToneDto(): DefaultToneDto;
}

export class DefaultToneResponseDtoImpl extends APIResponseDtoImpl implements DefaultToneResponse 
{
    private defaultToneResponseDto : DefaultToneDto;

    getDefaultToneDto(): DefaultToneDto
    {
        return this.defaultToneResponseDto;
    }
    setDefaultToneDto(defaultToneResponseDto: DefaultToneDto)
    {
        this.defaultToneResponseDto = defaultToneResponseDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/defaulttone/defaulttoneresponse.ts